import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import type { GuestFreeUsageApi } from '../guest-free-usage-api';

/** 游客免费使用资格的 HTTP API 实现。 */
@injectable()
export class GuestFreeUsageApiImpl extends PsHttpService implements GuestFreeUsageApi {
    /** Telecom API 的基础地址和版本请求头。 */
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    /**
     * 请求后端判断当前用户是否可免费执行一次指定 AI 任务。
     * @param taskType 后端定义的统一 AI 任务类型。
     */
    async canUseOnce(taskType: string): Promise<boolean> {
        /** 后端统一成功响应中的资格判断结果。 */
        const result = await this.get<PatSnapSuccessResponseData<boolean>>({
            url: 'ai/task/can-use-once',
            params: {
                task_type: taskType,
            },
        });
        return result.data;
    }
}
